<template>
  <div class="smy__card-full-box">
    <Card :bordered="false" class="smy__card-full">
      <p slot="title">开票管理</p>
      <div class="search">
        <!-- 详细筛选条件 -->
        <div>
          <div
            class="search-detail"
            :class="{ 'search-detail-close': !searchVisible }"
            :style="{ overflow: !searchVisible ? 'hidden' : '' }"
          >
            <div class="search-detail-item">
              <Input
                class="search-input"
                placeholder="请输入订单号"
                v-model="searchForm.order_no"
              ></Input>
            </div>
            <div class="search-detail-item">
              <Select
                clearable
                filterable
                class="search-input"
                placeholder="请选择是否开票"
                element-id="is_invoice"
                v-model="searchForm.is_invoice"
              >
                <Option
                  v-for="spareType in invoice"
                  :key="spareType.id"
                  :value="spareType.id"
                >
                  {{ spareType.name }}
                </Option>
              </Select>
            </div>
            <div class="search-detail-item">
              <Input
                class="search-input"
                placeholder="请输入企业名称"
                v-model="searchForm.ep_name"
              ></Input>
            </div>
            <div class="search-detail-item">
              <Select
                clearable
                filterable
                class="search-input"
                placeholder="请选择是否是特殊订单"
                element-id="is_special"
                v-model="searchForm.is_special"
              >
                <Option
                  v-for="spareType in special"
                  :key="spareType.id"
                  :value="spareType.id"
                >
                  {{ spareType.name }}
                </Option>
              </Select>
            </div>
            <div class="search-detail-item">
              <Select
                clearable
                filterable
                class="search-input"
                placeholder="请选择订单类型"
                element-id="ordertype"
                v-model="searchForm.type"
              >
                <Option
                  v-for="spareType in orderList"
                  :key="spareType.id"
                  :value="spareType.id"
                >
                  {{ spareType.name }}
                </Option>
              </Select>
            </div>
            <div class="search-detail-item">
              <DateRangePicker
                class="search-input"
                :placeholder="'请选择开通时间'"
                :value="emptyOpenTime"
                @on-change="
                  daterangeOpenChange(
                    $event,
                    'inception_start_time',
                    'inception_end_time'
                  )
                "
              />
            </div>
            <div class="search-detail-item">
              <Button
                type="primary"
                class="search-button"
                @click=";(pageIndex = 0), loadList()"
              >
                查找
              </Button>
              <Button class="search-button" @click="resetSearchForm">
                重置
              </Button>
              <FilterColumn
                :column="allColumns"
                @columnsChecked="columnsChecked = $event"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- 工单列表 -->
      <div class="table">
        <Table
          stripe
          ref="table"
          :loading="listLoading"
          :columns="columns"
          :data="list"
          @on-selection-change="selection = $event"
        ></Table>
      </div>
      <!-- 分页控件 -->
      <Page
        show-total
        show-sizer
        class="page"
        placement="top"
        :current="pageIndex + 1"
        :total="count"
        :page-size-opts="pageSizeOpts"
        @on-change="pageIndexChange"
        @on-page-size-change="pageSizeChange"
      ></Page>
    </Card>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import DateRangePicker from '@/components/DateRangePicker'

export default {
  components: {
    DateRangePicker,
  },
  data() {
    return {
      columnsChecked: [],
      emptyOpenTime: ['', ''],
      palyName: '',
      busType: '',
      buyPeople: '',
      corpid: '',
      BUYButton: 0,
      editModal: false, // 购买弹窗
      planId: 1,
      editTitle: '购买',
      type: 1,
      editReportCurstom: false, // 报备客户
      searchVisible: true, // 是否显示详细筛选条件
      pageSize: 10,
      pageIndex: 0,
      listLoading: false, // 表格加载状态
      count: 0,
      list: [],
      selection: [],
      searchForm: {
        order_no: '',
        ep_name: '',
        inception_start_time: '',
        inception_end_time: '',
        type: '',
        is_special: '',
        is_invoice: '',
      },
      invoice: [
        {
          id: '-1',
          name: '全选',
        },
        {
          id: '0',
          name: '未开票',
        },
        {
          id: '1',
          name: '已开票',
        },
      ],
      special: [
        {
          id: '-1',
          name: '全选',
        },
        {
          id: '0',
          name: '否',
        },
        {
          id: '1',
          name: '是',
        },
      ],
      orderList: [
        {
          id: '1',
          name: '购买',
        },
        {
          id: '2',
          name: '升级',
        },
        {
          id: '3',
          name: '续费',
        },
      ],
      roderstateList: [
        {
          id: '1',
          name: '订单审批中',
        },
        {
          id: '2',
          name: '订单处理中',
        },
        {
          id: '3',
          name: '订单已完成',
        },
        {
          id: '0',
          name: '订单已驳回',
        },
      ],
    }
  },
  computed: {
    ...mapState('table', ['columnsCheckedAll', 'pageSizeOpts']),
    // 表格列 根据选中的列动态生成
    allColumns() {
      const allColumns = [
        {
          title: '操作',
          width: 120,
          align: 'center',
          fixed: 'right',
          render: (h, { row }) => {
            let check = h(
              'Button',
              {
                props: {
                  type: 'ghost',
                  size: 'small',
                },
                on: {
                  click: () => {
                    this.$router.push({
                      name: 'QdInvoiceDetailDetail',
                      params: { orderId: row.id },
                    })
                  },
                },
                style: {
                  marginLeft: '10px',
                },
              },
              ['查看订单']
            )
            return h('span', [check])
          },
        },
        {
          title: '订单号',
          key: 'order_no',
          width: 180,
          ellipsis: true,
        },
        {
          title: '是否已开票',
          key: 'is_special',
          width: 140,
          render: (h, { row }) => {
            let special = ''
            if (row.is_invoice === 0) {
              special = '未开票'
            } else if (row.is_invoice === 1) {
              special = '已开票'
            }
            return h('span', [special])
          },
        },
        {
          title: '企业名称',
          key: 'ep_name',
          width: 140,
          ellipsis: true,
        },
        {
          title: '代理商业务员',
          key: 'business_user_name',
          width: 120,
        },
        {
          title: '代理商',
          key: 'agent_name',
          width: 120,
        },
        {
          title: '订单类型',
          key: 'type',
          width: 120,
          render: (h, { row }) => {
            let special = ''
            if (row.type === 1) {
              special = '购买'
            } else if (row.type === 2) {
              special = '升级'
            } else if (row.type === 3) {
              special = '续费'
            }
            return h('span', [special])
          },
        },
        {
          title: '订单内容',
          key: 'use_year_type',
          width: 140,
          render: (h, { row }) => {
            let Year = row.use_year_type
            for (var item of this.buyPeople) {
              if (item.value === row.fk_t_charge_package_id) {
                if (row.type === 2) {
                  if (row.fk_t_charge_package_id === 8) {
                    return h('span', ['不限工号'])
                  } else {
                    return h('span', [item.maxNum + '用户'])
                  }
                } else {
                  if (row.fk_t_charge_package_id === 8) {
                    return h('span', ['不限工号' + Year + '年'])
                  } else {
                    return h('span', [item.maxNum + '用户' + Year + '年'])
                  }
                }
              }
            }
          },
        },
        {
          title: '是否为特殊订单',
          key: 'create_time',
          width: 140,
          render: (h, { row }) => {
            let specialOrder = ''
            if (row.is_special === 1) {
              specialOrder = '是'
            } else {
              specialOrder = '-'
            }
            return h('span', [specialOrder])
          },
        },
        {
          title: '代理付款金额',
          key: 'agent_pay_price',
          width: 140,
        },
        {
          title: '开通时间',
          key: 'inception_start_time',
          width: 180,
        },
        {
          title: ' ',
          key: ' ',
        },
      ]
      return allColumns
    },
    columns() {
      const allColumns = this.allColumns
      let arr = allColumns.filter((col) => {
        if (!col.key || !col.key.trim()) {
          return true
        } else {
          if (this.columnsChecked.length) {
            return this.columnsChecked.includes(col.key)
          } else {
            return true
          }
        }
      })
      if (this.columnsChecked.length) {
        let indexMap = this.columnsChecked.reduce((p, c, i) => {
          p[c] = i
          return p
        }, {})
        let left = arr.filter((col) => this.columnsChecked.includes(col.key))
        let right = arr.filter((col) => !this.columnsChecked.includes(col.key))
        arr = left
          .sort((p, c) => indexMap[p.key] - indexMap[c.key])
          .concat(right)
      }
      return arr
    },
  },
  watch: {
    selection(val) {
      console.log(val)
    },
  },
  methods: {
    openEdit() {
      if (this.selection.length <= 0) {
        this.$Message.warning('请选择申请开票的订单')
        return
      }
      this.editModal = true
    },
    // 加载列表数据
    loadList() {
      this.listLoading = true
      this.$http
        .all([
          this.$http.get('/invoice/order/list', {
            params: {
              pageIndex: this.pageIndex,
              pageSize: this.pageSize,
              ...this.searchForm,
            },
          }),

          this.$http.get('/invoice/order/count', {
            params: this.searchForm,
          }),
        ])
        .then(
          this.$http.spread((res1, res2) => {
            this.list = res1.data
            this.count = res2.data
            this.listLoading = false
          })
        )
    },
    // 分页 每页大小 改变回调
    pageSizeChange(pageSize) {
      this.pageSize = pageSize
      this.loadList()
    },
    // 分页 页码 改变回调
    pageIndexChange(pageIndex) {
      this.pageIndex = pageIndex - 1
      this.loadList()
    },
    // 日期 改变回调
    daterangeOpenChange(daterange, start, end) {
      if (daterange[0]) {
        this.searchForm[start] = daterange[0]
          .replace('/', '-')
          .replace('/', '-')
        this.searchForm[end] = daterange[1].replace('/', '-').replace('/', '-')
      } else {
        this.searchForm[start] = ''
        this.searchForm[end] = ''
      }
      this.emptyOpenTime = [this.searchForm[start], this.searchForm[end]]
    },
    // 重置搜索框
    resetSearchForm() {
      this.emptyOpenTime = ['', '']
      this.searchForm = {
        order_no: '',
        ep_name: '',
        inception_start_time: '',
        inception_end_time: '',
        type: '',
        is_special: '',
        is_invoice: '',
      }
      this.loadList()
    },
    editReport() {
      this.editReportCurstom = true
    },
  },
  created() {
    this.$http.get('/dropdown/industry').then((res) => {
      this.busType = res.data
    })
    this.$http.get('/dropdown/chargePackage').then((res) => {
      this.buyPeople = res.data
    })
    this.loadList()
  },
}
</script>

<style lang="less" scoped>
.search {
  margin-bottom: 16px;
  .search-top {
    display: flex;
    justify-content: space-between;

    .search-top-left {
      display: flex;
      width: 70%;

      .search-input {
        width: 80%;

        // margin-left: 10px;
      }

      .search-button {
        margin-left: 10px;
      }
    }

    .search-top-right {
      .filter-column {
        display: flex;
        flex-direction: column;
        overflow: hidden;
      }

      .search-button {
        margin-left: 6px;
      }
    }
  }

  .search-detail {
    display: flex;
    flex-wrap: wrap;
    height: 80px;
    transition: 0.5s;

    .search-detail-item {
      width: 24.25%;

      .search-input {
        width: 100%;
        margin-bottom: 10px;
      }

      .search-button {
        margin-right: 6px;
      }
    }

    .search-detail-item:nth-child(2n + 1),
    .search-detail-item:nth-child(4n + 2) {
      margin-right: 1%;
    }
  }

  .search-detail-close {
    height: 0;
    opacity: 0;
  }
}

.page {
  margin-top: 20px;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/invoiceManage/invoiceManage/index.vue